import { DATA_SOURCE_UI_COLUMN_WINDOW_MAX_LIMIT } from '../../core/data-source/window.js';
import type { SingleView } from '../../core/view-manager/single-view.js';
import type { TableViewSelectionWithType } from './selection.js';

export function isTableSelectionWithinCanonicalBounds(
  view: SingleView,
  selection?: TableViewSelectionWithType
): boolean {
  if (!selection || selection.selectionType === 'row') {
    return true;
  }

  const { columnIndex, rowIndex } = selection.focus;
  if (
    !Number.isInteger(rowIndex) ||
    rowIndex < 0 ||
    rowIndex >= view.rowCount$.value
  ) {
    return false;
  }

  if (!Number.isInteger(columnIndex) || columnIndex < 0) return false;

  // columnCount includes hidden/system properties. Respect the UI read cap
  // while counting the canonical visible sequence, independent of render width.
  const rawColumnCount = view.columnCount$.value;
  let visibleColumnCount = 0;
  for (
    let offset = 0;
    offset < rawColumnCount;
    offset += DATA_SOURCE_UI_COLUMN_WINDOW_MAX_LIMIT
  ) {
    visibleColumnCount += view.getPropertiesWindow({
      offset,
      limit: Math.min(
        DATA_SOURCE_UI_COLUMN_WINDOW_MAX_LIMIT,
        rawColumnCount - offset
      ),
    }).properties.length;
    if (columnIndex < visibleColumnCount) return true;
  }
  return false;
}
